<script setup lang="ts">
import { computed } from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'
import { STATUS_COLORS, I18N_PREFIXES, type StatusType } from './base-pill.types'

const props = defineProps<{
  type: StatusType
  status: string
}>()

const color = computed(() => {
  const statusMap = STATUS_COLORS[props.type]

  return statusMap[props.status as keyof typeof statusMap]
})

const label = computed(() => i18n.t(`${I18N_PREFIXES[props.type]}.${props.status.toUpperCase()}`))
</script>

<template>
  <sword-tag :color="color">
    <span class="t3 font-medium">{{ label }}</span>
  </sword-tag>
</template>
